import { BaseModel } from '../BaseModel/BaseModel';
import { CategoryEntity, RawCategory } from './Types';

export class CategoryModel extends BaseModel<RawCategory, CategoryEntity> implements CategoryEntity {
    category: string  = '';
    createdAt: string = new Date().toISOString();
    deletedAt: string | null = null;
    description: string = '';
    id: number = 0;
    slug: string | null = null;
    updatedAt: string = new Date().toISOString();

    constructor(category?: RawCategory) {
        super();
        if(category) {
            this.initialize(category)
        }
    }

    initialize(raw: RawCategory) {
        this.category = raw.category;
        this.createdAt = raw.created_at;
        this.deletedAt = raw.deleted_at;
        this.description = raw.description;
        this.id = raw.id;
        this.slug = raw.slug;
        this.updatedAt = raw.updated_at;
    }

    parse(): RawCategory {
        return {
            category: this.category,
            created_at: this.createdAt,
            deleted_at: this.deletedAt,
            description: this.description,
            id: this.id,
            slug: this.slug,
            updated_at: this.updatedAt,
        }
    }
}